var exports = {
  "kL": "ChannelDivider.module__container___NUdXVz",
  "JW": "ChannelDivider.module__unreadContainer___NUdXVz",
  "iN": "ChannelDivider.module__unreadDate___NUdXVz",
  "n8": "ChannelDivider.module__line___NUdXVz",
  "Qq": "ChannelDivider.module__text___NUdXVz",
  "KQ": "ChannelDivider.module__unreadLine___NUdXVz",
  "vD": "ChannelDivider.module__dateWithUnreadText___NUdXVz",
  "HN": "ChannelDivider.module__unreadBadge___NUdXVz",
};

module.exports = exports;
